import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import AnimatedLetters from '../AnimatedLetters'
import './index.scss'
import { useEffect, useState } from 'react'
import { faBootstrap, faGitAlt, faJsSquare, faReact } from '@fortawesome/free-brands-svg-icons'
import Loader from 'react-loaders'
import djangoLogo from '../../assets/images/django.png'
import pythonLogo from '../../assets/images/python.png'

const Projects = () => {
  const [letterClass, setLetterClass] = useState('text-animate')

  useEffect(() => {
    setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 3000)
  }, [])

  return (
    <>
    <div className="container projects-page">
      <div className="text-zone">
        <h1>
          <AnimatedLetters
            str={'Projects'}
            index={15}
            letterClass={letterClass}
          />
        </h1>
        
        <div className='project-link-wrapper'><a className='project-link' rel="noreferrer" href='https://formulapakistan.pk' target='_blank'><div className='project'>Formula Pakistan <span className='project-tech'> React - Tailwind - Vite - Vercel</span></div></a></div>
        <div className='project-link-wrapper'><a className='project-link' rel="noreferrer" href='https://impactor-neo.vercel.app/' target='_blank'><div className='project'>Impactor NEO <span className='project-tech'> React - Tailwind - Vite - NASA API - Vercel</span></div></a></div>
        <div className='project-link-wrapper'><a className='project-link' rel="noreferrer" href='https://movie-recommender-cgan.streamlit.app/' target='_blank'><div className='project'>CGAN Based Movie Recommender System <span className='project-tech'> Python - PyTorch - Streamlit - NumPy</span></div></a></div>
        <div className='project-link-wrapper'><a className='project-link' rel="noreferrer" href='https://campuspulses.vercel.app/' target='_blank'><div className='project'>Campus Pulse <span className='project-tech'> React - TypeScript - Supabase - Recharts - Tailwind CSS</span></div></a></div>
        <div className='project-link-wrapper'><a className='project-link' rel="noreferrer" href='https://tech-heist-dev-day.vercel.app/' target='_blank'><div className='project'>Tech Heist <span className='project-tech'> React - Vite - Supabase - Vercel</span></div></a></div>
        <div className='project-link-wrapper'><a className='project-link' rel="noreferrer" href='https://github.com/SaadHusayn/social-network' target='_blank'><div className='project'>Social Network <span className='project-tech'> Django - React - Tailwind - REST APIs</span></div></a></div>
        <div className='project-link-wrapper'><a className='project-link' rel="noreferrer" href='https://github.com/SaadHusayn/news-dashboard' target='_blank'><div className='project'>Multithreaded News Dashboard <span className='project-tech'> C - Pthreads - Bash - GeminiAPI</span></div></a></div>
        <div className='project-link-wrapper'><a className='project-link' rel="noreferrer" href='https://github.com/SaadHusayn/commerce/' target='_blank'><div className='project'>E-Commerce Auctions App <span className='project-tech'> Django - Bootstrap - SQLite</span></div></a></div>
        <div className='project-link-wrapper'><a className='project-link' rel="noreferrer" href='https://github.com/SaadHusayn/pda-for-palindromes-visualizer' target='_blank'><div className='project'>PDA for Palindromes Visualizer <span className='project-tech'> Python - Tkinter </span></div></a></div>

      </div>

      <div className='stage-cube-cont'>
        <div className='cubespinner'>
            <div className='face1'>
                <FontAwesomeIcon icon={faReact} color='#1082A7' />
            </div>

            <div className='face2'>
                <img style={{"width":"100px"}} src={pythonLogo} alt='python' />
            </div>

            <div className='face3'>
                <FontAwesomeIcon icon={faBootstrap} color='#8B19FE' />
            </div>

            <div className='face4'>
                <FontAwesomeIcon icon={faGitAlt} color='#F05539' />
            </div>

            <div className='face5'>
                <FontAwesomeIcon icon={faJsSquare} color='#F7E025' />
            </div>

            <div className='face6'>
                <img style={{"width":"100px"}} src={djangoLogo} alt='django' />
            </div>
        </div>
      </div>
    </div>

    <Loader type='pacman' />
    </>
    
  )
}

export default Projects
